import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';

const GET_INVOICES = gql`
  query GetInvoices($year: Int!) {
    invoices(year: $year) {
      invoices {
        year
        uuid
        periodStart
        periodEnd
        invoiceDate
        month
        commission
        manualCommission
        invoiceNumber
        daysWorked
        dailyRateConsultant
        dailyRateClient
        currency
        clientName
        amountConsultant
        amountClient
      }
      year
    }
  }
`;

export const useInvoices = (year = null) => {

    const { data, loading, error, refetch } = useQuery(GET_INVOICES, {
        variables: { year },
        fetchPolicy: "network-only",
        skip: !year,
    });

    return {
        data: data?.invoices?.invoices || [],
        loading,
        error,
        refetch,
    };
};
